import { ApiBind, CommonSearchParam } from './common-search-param.model';


export class PlatformOSGroupSearchParam extends CommonSearchParam {

  constructor(
    platformId?: number,
    mediaTypes?: string,
    adFormats?: string,
    osGroupSettings?: string,
    osGroupId?: number,
  ) {
    super();
    this.platformId = platformId;
    this.mediaTypes = mediaTypes;
    this.adFormats = adFormats;
    this.osGroupSettings = osGroupSettings;
    this.osGroupId = osGroupId;
  }

  @ApiBind({ column: 'platform_id' })
  platformId: number;

  @ApiBind({ column: 'media_types' })
  mediaTypes: string;

  @ApiBind({ column: 'ad_formats' })
  adFormats: string;

  @ApiBind({ column: 'os_group_settings' })
  osGroupSettings: string;

  @ApiBind({ column: 'os_group_id' })
  osGroupId: number;
}
